import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

import en from './locales/en.json'
import enGB from './locales/en-GB.json'
import nb from './locales/nb.json'
import da from './locales/da.json'
import sv from './locales/sv.json'
import de from './locales/de.json'

const STORAGE_KEY = 'kobsign-word-addin-language'
const supportedLanguages = ['en', 'en-GB', 'nb', 'da', 'sv', 'de']

function detectLanguage(): string {
  // 1. Check localStorage
  const savedLang = localStorage.getItem(STORAGE_KEY)
  if (savedLang && supportedLanguages.includes(savedLang)) {
    return savedLang
  }

  // 2. Check Office display language (if available)
  try {
    const officeLocale = Office?.context?.displayLanguage
    if (officeLocale) {
      // Check full locale first (e.g. en-GB)
      if (supportedLanguages.includes(officeLocale)) {
        return officeLocale
      }
      const lang = officeLocale.split('-')[0]
      if (supportedLanguages.includes(lang)) {
        return lang
      }
    }
  } catch {
    // Office.js not yet initialized — fall through
  }

  // 3. Check browser language
  const browserFull = navigator.language // e.g. "en-GB", "de-DE"
  if (supportedLanguages.includes(browserFull)) {
    return browserFull
  }
  const browserLang = browserFull.split('-')[0]
  if (supportedLanguages.includes(browserLang)) {
    return browserLang
  }

  // 4. Fallback to English
  return 'en'
}

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    'en-GB': { translation: enGB },
    nb: { translation: nb },
    da: { translation: da },
    sv: { translation: sv },
    de: { translation: de },
  },
  lng: detectLanguage(),
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false,
  },
})

// Save language preference when changed
i18n.on('languageChanged', (lng) => {
  localStorage.setItem(STORAGE_KEY, lng)
})

export const supportedLangs = supportedLanguages
export default i18n
